export const findAssetByTitle = (title, assets) => {
  return assets.find(asset =>
    asset.rlx_responsive_asset_id.title.toLowerCase() === title.toLowerCase()
  );
}

export const spacingToTwClass = (spacing) => {
  if (spacing === null) return '';
  const spacingMap = {
    mt: 'mt-[8vh]',
    mb: 'mb-[8vh]',
    pt: 'pt-[8vh]',
    pb: 'pb-[8vh]',
  }
  const spacingClassNames = spacing.map(s => spacingMap[s]);
  return spacingClassNames.join(' ');
}

export const colorToTwClass = (color) => {
  const sectionBackgroundColorMap = {
    '#F9F7F4': 'bg-light-beige',
    '#F4EFEA': 'bg-beige',
  }
  return sectionBackgroundColorMap[color]
}

export function chunkArray(array, chunkSize) {
  const results = [];
  while (array.length) {
    results.push(array.splice(0, chunkSize));
  }
  return results;
}

export const weekDayTranslTable = {
  'monday': {
    short: 'Mo',
    long: 'Montag',
  },
  'tuesday': {
    short: 'Di',
    long: 'Dienstag',
  },
  'wednesday': {
    short: 'Mi',
    long: 'Mittwoch',
  },
  'thursday': {
    short: 'Do',
    long: 'Donnerstag',
  },
  'friday': {
    short: 'Fr',
    long: 'Freitag',
  },
  'saturday': {
    short: 'Sa',
    long: 'Samstag',
  },
  'sunday': {
    short: 'So',
    long: 'Sonntag',
  },
}

export const simpleTranslTable = {
  'germany': 'Deutschland',
}
